import type { Option } from '@components/forms/GridSelect';

export enum SystemFilterOption {
    Model = 'model',
    Status = 'status',
}

export enum SystemAssigned {
    Assigned = 'assigned',
    Unassigned = 'unassigned',
}

export enum System {
    RapidCut = 'RC2/RC3',
    RCMini = 'RCMini',
}

export enum SystemModel {
    RC = 0,
    RCMINI = 1,
}

export enum SystemStatus {
    Active = 'Active',
    Inactive = 'Inactive',
}

export const SystemModelMap: { [key: string]: System } = {
    0: System.RapidCut,
    1: System.RCMini,
};

export const SystemVariantMap: { [key: string]: string } = {
    67: 'RCMini',
    4386: 'RC 2.0',
    4400: 'RC 2.1',
    10: 'RC 3.0',
};

/**
 * Model filter options mapping ProductID to searchable display names.
 * Used for filtering systems by model variant (2.0, 2.1, 3.0, Mini).
 */
export const MODEL_FILTER_OPTIONS = [
    { productId: '4386', label: 'RC 2.0' },
    { productId: '4400', label: 'RC 2.1' },
    { productId: '10', label: 'RC 3.0' },
    { productId: '67', label: 'RCMini' },
];

export const SYSTEM_STATUS_OPTIONS: Option[] = Object.entries(SystemStatus).map(([label, value]) => {
    return {
        label,
        value,
    };
});

export const COMPATIBILITY_OPTIONS = [System.RCMini, System.RapidCut];
